import { render, staticRenderFns } from "./CouponIssue.vue?vue&type=template&id=046d83cc&scoped=true"
import script from "./CouponIssue.vue?vue&type=script&lang=js"
export * from "./CouponIssue.vue?vue&type=script&lang=js"
import style0 from "./CouponIssue.vue?vue&type=style&index=0&id=046d83cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d83cc",
  null
  
)

export default component.exports